module.exports = __webpack_public_path__ + "media/images/patent/y_14-873ac1a7c1ae4fe3cee889d5a7004e7f.jpg";